import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Routing from "./route/routing";
import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  const location = useLocation();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      disable: () => {
        return window.innerWidth <= 768; // disable on screens smaller than 1024px
      },
    });
  }, [location]);
  return (
    <>
      <Routing />
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
};

export default App;
